// extracted by mini-css-extract-plugin
export var active = "_j4-2";
export var recordingDot = "_j4-1";
export var recordingIndicator = "_j4-0";